import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/auth/auth.service';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm!: FormGroup;
  adminLoginPage: any = {};
  constructor(public router: Router, private authService: AuthService, private toastrService: ToastrService, private appService: AppService) { }

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
    this.adminLoginPage = this.appService.getPageByKey('adminLogin');
    console.log(this.adminLoginPage);
  }

  onLogin() {
    if (this.loginForm.valid) {
      let data = this.loginForm.value;
      if (!this.adminLoginPage.title.includes(data.username)) {
        this.toastrService.error('Please enter valid username and password', 'Error');
        return false;
      } else {
        this.appService.hashPassword(this.loginForm.value.password).then((res: any) => {
          data.password = res;
          this.authService.loginUser(data).subscribe((res: any) => {
            sessionStorage.setItem("access_token", res.access_token);
            sessionStorage.setItem("admin_token", res.access_token);
            sessionStorage.setItem("loginUserId", res.user_id);
            sessionStorage.setItem('userDetails', JSON.stringify(res));
            this.router.navigate(['/admin/v1/dashboard']);
          });
        });
      }
    }
    return false;
  }

}
